import { Image, Nav, Navbar } from "react-bootstrap";

import Flag from '../images/BandieraInglese.svg'
import { LinkContainer } from "react-router-bootstrap";
import React from "react";

const styleScrittaAgu = {
    maxHeight: "15vh",
    padding: 0,
    margin: 0,
};

const styleNavBar = {
    padding: "0",
    position: "sticky",
};

const styleNavBackground = {
    background: "black", // Black background
    width: "100%", // Full page width
    display: "flex",
    flexDirection: "column", // Align items vertically
    paddingLeft: "80px",
};

const styleNavItems = {
    color: "white", // White text color
};
const activeStyleNavItems = {
    textDecoration: "underline white"
};

const styleTest = {
    flexDirection: "column", // Align items vertically
    alignItems: "flex-start", // Align items to the left
};

const selectPage = () => {
    window.scrollTo(0, 0);
}

export const NavigationBar = () => (
    <Navbar bg="white" expand="lg" sticky="top" style={styleNavBar}>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" style={styleTest}>
            <Image src="/images/scrittaAgu.png" style={styleScrittaAgu} />
            <div style={styleNavBackground} className="mt-auto">
                <Nav>
                    <LinkContainer to="/" style={styleNavItems} activeStyle={activeStyleNavItems} onClick={() => selectPage()}>
                        <Nav.Link >Benvenuti</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/storia" style={styleNavItems} activeStyle={activeStyleNavItems} onClick={() => selectPage()}>
                        <Nav.Link>Storia</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/vigneti" style={styleNavItems} activeStyle={activeStyleNavItems} onClick={() => selectPage()}>
                        <Nav.Link>Vigneti</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/vini" style={styleNavItems} activeStyle={activeStyleNavItems} onClick={() => selectPage()}>
                        <Nav.Link>Vini</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/contatti" style={styleNavItems} activeStyle={activeStyleNavItems} onClick={() => selectPage()}>
                        <Nav.Link>Contatti</Nav.Link>
                    </LinkContainer>
                    <a href="https://agu.sumupstore.com/prodotti"> Negozio</a>
                    <LinkContainer className="ms-auto" to="/en" style={styleNavItems} activeStyle={activeStyleNavItems} onClick={() => selectPage()}>
                        <Nav.Link><Image src={Flag} style={{ width: '25px' }} alt="English Flag" /> Eng</Nav.Link>
                    </LinkContainer>
                </Nav>
            </div>
        </Navbar.Collapse>
    </Navbar>
);